// App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./components/layout/Layout"; // Import the layout
import { BrandingProvider } from "./providers/BrandingProvider";
import { AuthProvider } from "./contexts/AuthContext";
import RedirectLogin from "./pages/common/EmailRedirect";
import LoginForm from "./pages/common/LoginPage";
import RegisterPage from "./pages/common/RegistrationPage";
import ForgotPassword from "./pages/common/ForgetPasswordPage";
import FeedbackSubmitPage from "./pages/common/FeedbackSubmitPage";
import ErrorPage from "./pages/common/ErrorPage";
import RestrcitionPage from "./pages/common/RestrictionPage";
import InterviewInstructionPage from "./pages/common/InterviewInstructionPage";
import EmailVerificationPage from "./pages/common/EmailVerificationPage";
import InterviewPage from "./pages/common/InterviewPage";
import ReschedulePage from "./pages/common/ReschedulePage";

import JdAnalysisPage from "./pages/recuriter/JdAnalysisPage";
import JDGeneratorPage from "./pages/recuriter/JdGenerator";
import RecruiterDashboard from "./pages/recuriter/RecuriterDashboardPage";
import CandidateReportDetailPage from "./pages/recuriter/CandidateReportDetailPage";
import CandidateReoprtListPage from "./pages/recuriter/CandidateReportListPage";
import InterviewAnalysisPage from "./pages/recuriter/InterviewAnalysisPage";
import RecuriterLandingPage from "./pages/recuriter/RecuriterLandingPage";
import QuestionGenerationPage from "./pages/recuriter/QuestionGenerationPage";
import ResumeAnalysisPage from "./pages/recuriter/ResumeAnalysisPage";
import SettingsPage from "./pages/recuriter/SettingsPage";
import UserGuide from './pages/common/HelpDeskPage'

import FeedbackListPage from "./pages/superAdmin/FeedbackListPage";
import SuperAdminLandingPage from "./pages/superAdmin/SuperAdminLandingPage";
import TenantDetailPage from "./pages/superAdmin/TenantDetailPage";
import TenantOnboardingPage from "./pages/superAdmin/TenantOnbordingPage";
import TenantManagementPage from "./pages/superAdmin/TenantManagementPage";
import DemoUserListPage from "./pages/superAdmin/DemoUserListPage";

import RecruiterManagementPage from "./pages/admin/RecruiterManagementPage"
import AdminDashboardPage from "./pages/admin/AdminDashboardPage";
import AdminSettingsPage from "./pages/admin/AdminSettingsPage";
import TenantConfigurationPage from "./pages/admin/SettingsPage";
import RecruiterSettingsPage from "./pages/recuriter/RecruiterSettingsPage";

import UserLandingPage from './pages/users/UserLandingPage'
// import GenerateQuestionsPage from "./pages/recuriter/QuestionGenerationPage";
import FlowiseInterview from "./pages/common/FlowiseInterview";
import SuccessPage from "./pages/common/SuccessPage";
import ResumeMatcherLLMPage from "./pages/recuriter/ResumeMatcherLLMPage ";
import TenantRegisterPage from "./pages/common/Tenantregisterpage";
import SubscriptionPlanSetting from "./pages/superAdmin/SubscriptionPlanSetting";
import TenantTokenUsagePage from "./pages/superAdmin/TenantTokenDeatils";

import WithMaintenanceCheck from "./pages/common/MaintenancePage";
import Home from "./pages/common/Home";
import ContactUs from "./pages/common/ContactUs";
import PrivacyPolicy from "./components/HomePage/PrivacyPolicy/PrivacyPolicy";
import MarketingLayout from "./components/layout/MarketingLayout";
import ThemeLayout from "./components/layout/ThemeLayout";
import PricingDetail from "./components/HomePage/pricing/PricingDetail"
import AuthCallback from "./pages/common/AuthCallback";
import GeneratePasswordPage from "./pages/recuriter/GeneratePasswordPage";
import QuestionsPage from "./pages/recuriter/QuestionsPage";

function App() {
  return (
    <WithMaintenanceCheck>
      <AuthProvider>
      <BrandingProvider>
      <Router>
        <Routes>
          {/* Marketing / landing routes with marketing-only theme */}
          <Route element={<MarketingLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/pricing-detail" element={<PricingDetail />} />
          </Route>

          {/* Core application routes with ThemeContextProvider */}
          <Route element={<ThemeLayout />}>
            <Route path="/help/desk/" element={<UserGuide />} />
            <Route path="/interview/reschedule/:interview_id/:recruiter_id" element={<ReschedulePage />} />
            <Route path="/email/redirect" element={<RedirectLogin />} />
            <Route path="/login" element={<LoginForm />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/forgot/password" element={<ForgotPassword />} />
            <Route path="/error" element={<ErrorPage />} />
            <Route path="/restriction" element={<RestrcitionPage />} />
            <Route path="/interview/instruction" element={<InterviewInstructionPage />} />
            <Route path="/interview" element={<InterviewPage />} />
            <Route path="/success" element={<SuccessPage />} />
            <Route path="/tenantRegister" element={<TenantRegisterPage />} />
            <Route path="/flowiseInterview" element={<FlowiseInterview />} />
            <Route path="/interview/emailvar/:interview_id/:recruiter_id" element={<EmailVerificationPage />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/generate-password" element={<GeneratePasswordPage />} />

            {/* Routes with sidebar Layout */}
            <Route element={<Layout />}>
              <Route path="/tenant/management" element={<TenantManagementPage />} />
              <Route path="/tenant/token/detail" element={<TenantTokenUsagePage />} />
              <Route path="/admin/config/" element={<TenantConfigurationPage />} />
              <Route path="/recruiter/management" element={<RecruiterManagementPage />} />
              <Route path="/recruiter/dashboard" element={<RecruiterDashboard />} />
              <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
              <Route path="/admin-settings" element={<AdminSettingsPage />} />
              <Route path="/feedback" element={<FeedbackSubmitPage />} />
              {/* <Route path="/superadmin/landing" element={<SuperAdminLandingPage />} /> */}
              <Route path="/superadmin/demo-requests" element={<DemoUserListPage />} />
              <Route path="/tenant/details" element={<TenantDetailPage />} />
              <Route path="/tenant/onboarding" element={<TenantOnboardingPage />} />
              <Route path="/recruiter/landing" element={<RecuriterLandingPage />} />
              <Route path="/resume/analysis" element={<ResumeAnalysisPage />} />
              <Route path="/feedback/display" element={<FeedbackListPage />} />
              <Route path="/user/landing" element={<UserLandingPage />} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/recruiter-settings" element={<RecruiterSettingsPage />} />
              <Route path="/generate/question" element={<QuestionGenerationPage />} />
              <Route path="/recruiter/analysis" element={<JdAnalysisPage />} />
              <Route path="/interview/report" element={<InterviewAnalysisPage />} />
              <Route path="/reports/candidates" element={<CandidateReoprtListPage />} />
              <Route path="/reports/candidates/detail" element={<CandidateReportDetailPage />} />
              <Route path="/recruiter/llm-matching" element={<ResumeMatcherLLMPage />} />
              <Route path="/superadmin/plan-setting" element={<SubscriptionPlanSetting />} />
              <Route path="/recruiter/jd-generator" element={<JDGeneratorPage />} />
              <Route path="/recruiter/questions" element={<QuestionsPage />} />   
            </Route>
          </Route>
        </Routes>
      </Router>
      </BrandingProvider>
      </AuthProvider>
    </WithMaintenanceCheck>
  );
}

export default App;





























// // App.js
// import React from "react";
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// import JobUploadAndListing from "./pages/JobUploadAndListing";
// import MatchingPage from "./pages/MatchingPage";
// import InterviewPage from "./pages/InterviewPage";
// import InterviewInstructions from "./pages/InterviewInstructions";
// import LoginForm from "./pages/Login";
// import InterviewReport from "./pages/InterviewReport";
// import EmailVerification from "./pages/EmailVerification";
// import CareersPage from "./pages/CareersPage";
// import AppealingCandidateCard from "./pages/Test";
// import InterviewAnalysisPage from "./pages/InterviewAnalysisPage";
// import AccessRestricted from "./pages/AccessRestricted";
// import ErrorPage from "./pages/ErrorPage";
// import RegisterPage from "./pages/RegisterPage"
// import TokenManagement from "./pages/TokenManagement"

// import Layout from "./components/Layout"; // Import the layout
// import DirectInterviewPage from "./pages/DirectInterviewPage";
// import ForgotPassword from "./pages/forgotPassword";
// import Home from "./pages/Home";
// import RegistrationForm from "./pages/RegistrationForm";
// import ProtectedRoutes from "./Routes/ProtectedRoutes";
// import PublicRoutes from "./Routes/PublicRoutes";

// function App() {
//   return (
//     <Router>
//       <Routes>
//         {/* Routes without NavBar */}
//         <Route element={<PublicRoutes />}>
//           <Route path="/register" element={<RegisterPage />} />
//           <Route path="/" element={<LoginForm />} />
//           <Route path="/forgot-password" element={<ForgotPassword />} />
//           <Route path="/registration" element={<RegistrationForm />} />
//           <Route path="/direct-interview" element={<DirectInterviewPage />} />
//         </Route>
//         <Route element={<ProtectedRoutes />}>
//           <Route path="/interview" element={<InterviewPage />} />
//           <Route path="/interview/emailvar/:interview_id" element={<EmailVerification />} />
//           <Route path="/instruction" element={<InterviewInstructions />} />
//           <Route path="/restricted" element={<AccessRestricted />} />


//           <Route path="/home" element={<Home />} />
//           <Route path="/token" element={<TokenManagement />} />
//           <Route path="/upload" element={<JobUploadAndListing />} />
//           <Route path="/match-details/:id" element={<MatchingPage />} />




//           {/* Routes with NavBar via Layout */}
//           <Route element={<Layout />}>

//             {/* <Route path="/upload" element={<JobUploadAndListing />} />  */}
//             {/* <Route path="/match-details/:id" element={<MatchingPage />} /> */}
//             <Route path="/interview/report" element={<InterviewReport />} />
//             <Route path="/interview/analysis" element={<InterviewAnalysisPage />} />
//             <Route path="/user-dashboard" element={<CareersPage />} />

//             <Route path="/test" element={<AppealingCandidateCard />} />
//             {/* <Route path="/direct-interview" element={<DirectInterviewPage />} /> */}

//           </Route>
//         </Route>
//         <Route path="/error" element={<ErrorPage />} />

//       </Routes>
//     </Router>
//   );
// }

// export default App;
